import React, {createRef, useState, useContext} from 'react';
import __ from "lodash";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../../controls/Material-Table-Components';
import {Checkbox, useTheme} from "@material-ui/core";
import { v4 as uuidv4 } from 'uuid';

import SystemContext from "../../../../SystemContext";

import { ComboSelect } from '../../../../controls';
import FlightCrewLookup from "../../../Flights/components/FlightCrewLookup";
import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import CrewEditorValidator from "../../validators/CrewEditorValidator";


const CrewEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('Crew.AddFunction', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const props = {
    ..._props
  }
  const {classes, flightRecord, skeletonCrew} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const buildSkeletonCrew = (skeletonCrew) => {
    const crew = [];

    if (skeletonCrew && skeletonCrew.data) {
      skeletonCrew.data.forEach(item => {
        const pic = __.has(item, "data") && __.has(item.data, "pic") ? item.data.pic : false;

        const crewFunction = {
          crewUuid: uuidv4(),
          function: item.code,
          code: "",
          name: "",
          pic: pic,
          picAllowed: pic,
          sequence: item.sequence
        };
        crew.push(crewFunction);
      })
    }

    props.onChange({record: {...props.flightRecord, crew: crew}, oldRecord: props.flightRecord});

    return crew;
  }


  const flightCrew = __.orderBy(flightRecord.crew || buildSkeletonCrew(skeletonCrew), ['deadhead', 'sequence', 'function']);

  const clearAllOtherPics = () => {
    if (flightCrew) {
      flightCrew.forEach(crew => {
        crew.pic = false;
      })
    }
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(CrewEditorValidator, false);

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(50,2,undefined,undefined,{paddingLeft: 8},undefined,false),
        title: "Dead Head",
        field: "deadhead",
        emptyValue: false,
        initialEditValue: false,
        type: "boolean",
        render: rowData =>
          <Checkbox
            checked={(rowData.deadhead === 1 || rowData.deadhead === true) ?? true}
        />,
        editComponent: props =>
          <Checkbox
            checked={(props.rowData.deadhead === 1 || props.rowData.deadhead === true) ?? true}
            onChange={ (event, checked) => {
              props.onChange(checked)
            }}
          />
      },
      {
        ...baseColumn,
        ...ColumnWidth(150,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Function",
        field: "function",
        editComponent: (props) => (
          <ComboSelect
            id="function"
            group="CREW"
            subGroup="FUNCTION"
            fullWidth
            value={props.value}
            returnType={"object"}
            onChange={(value, returnObject) => {
              if (returnObject && !__.isEmpty(returnObject)) {
                const picAllowed =  returnObject.data?.pic || false;
                props.onRowDataChange({...props.rowData, function: value, pic: picAllowed ? props.rowData.pic : false, picAllowed, code: '', name: ''});
              } else {
                props.onChange(value);
              }
            }}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,undefined,undefined,false),
        title: "Code",
        field: "code",
        editComponent: (props) => (
          <FlightCrewLookup
            disabled={__.isEmpty(props.rowData.function)}
            value={props.value}
            function={props.rowData.function?.replace(/[0-9]/g, '')}
            returnType={"object"}
            onChange={(returnObject) => {
              if (returnObject.found) {
                const crewMember = returnObject.data
                const data = {
                  ...props.rowData,
                  code: crewMember.code,
                  name: crewMember.fullName,
                }
                props.onRowDataChange(data);
              } else {
                props.onChange(returnObject.value);
              }
            }}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(400,2,undefined,undefined,undefined,undefined,false),
        title: "Name",
        field: "name",
        editable: "never",
      },
      // {
      //   ...baseColumn,
      //   ...ColumnWidth(50,2,undefined,undefined,undefined,undefined,false),
      //   title: "PIC",
      //   field: "pic",
      //   emptyValue: false,
      //   initialEditValue: false,
      //   type: "boolean",
      //   render: rowData =>
      //     <Checkbox
      //       style={{padding: 0, color: `${rowData.picAllowed ? '#fc7c35' : '#a7a7a7' }`}}
      //       checked={(rowData.pic === 1 || rowData.pic === true) ?? true}
      //   />,
      //   editComponent: props =>
      //     <Checkbox
      //       style={{padding: 0, color: `${props.rowData.picAllowed ? '#fc7c35' : '#a7a7a7' }`}}
      //       checked={(props.rowData.pic === 1 || props.rowData.pic === true) ?? true}
      //       onChange={ (event, checked) => {
      //         if (!props.rowData.picAllowed)
      //           return;
      //         clearAllOtherPics();
      //         props.onChange(checked)
      //       }}
      //     />
      // },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor}>
          <MaterialTable
            tableRef={tableRef}
            data={flightCrew}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={250}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Flight Crew"
            columns={getColumns({...props, canEdit: state.canEdit})}
            actions={[
            ]}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    if (Array.isArray(flightCrew)) {
                      flightCrew.push({...newData, crewUuid: uuidv4()});
                      props.onChange({record: {...props.flightRecord, crew: flightCrew}, oldRecord: props.flightRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  })
                  : undefined,
              onRowUpdate: state.canEdit
                  ? (newData, oldData) => new Promise((resolve, reject) => {
                      let crewIdx = __.findIndex(flightCrew, {crewUuid: oldData.crewUuid});
                      if (crewIdx < 0) {
                        crewIdx =  __.findIndex(flightCrew, {code: oldData.code});
                      }
                      if (crewIdx >= 0) {
                        flightCrew[crewIdx] = newData;
                        props.onChange({record: {...props.flightRecord, crew: flightCrew}, oldRecord: props.flightRecord, resolve, reject});
                      } else {
                        reject();
                      }
                    })
                  : undefined,
              onRowDelete: state.canEdit
                ? (oldData) => new Promise((resolve, reject) => {
                    let crewIdx = __.findIndex(flightCrew, {crewUuid: oldData.crewUuid});
                    if (crewIdx < 0) {
                      crewIdx =  __.findIndex(flightCrew, {code: oldData.code});
                    }
                    if (crewIdx >= 0) {
                      flightCrew.splice(crewIdx, 1);
                      props.onChange({record: {...props.flightRecord, crew: flightCrew}, oldRecord: props.flightRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  })
                : undefined,
            }}
        />
      </div>
  );
}

export default CrewEditor;
